import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { ButtonProps } from '../Button';

export type LinkButtonProps = Omit<ButtonProps, 'onClick'> & {
  to: string;
};

export function LinkButton({
  children,
  className,
  colour = 'default',
  size = 'default',
  testId,
  to,
}: LinkButtonProps): ReactElement {
  const classes = classnames(
    'btn',
    `btn--${size}`,
    `btn--${colour}`,
    className,
  );

  return (
    <Link className={classes} to={to} data-testid={testId}>
      {children}
    </Link>
  );
}
